import TileTabs from './TileTabs';

export default TileTabs;
